module.exports = __webpack_public_path__ + "52e4103b67f1c98ad77be10638294fa3.png";